import { pl } from 'date-fns/locale';
const datePlPL = {
  name: 'pl-PL',
  locale: pl
};
export default datePlPL;